import React from 'react';
import { Card } from './ui';
import { Star, XCircle } from 'lucide-react';
export function Testimonials() {
  return <section className="py-10 bg-slate-900/50 border-y border-slate-800" data-id="element-39" data-mp="3mvc2oy90k2g4">
      <div className="max-w-6xl mx-auto px-4" data-id="element-40" data-mp="38x5bg0ykl0pf">
        <div className="flex flex-wrap justify-center gap-6 md:gap-14 text-center mt-[22px] mb-[22px]" data-id="element-41" data-mp="38wcefrpexpkh">
          <div data-id="element-42" data-mp="3dtvtuuxuk8e0">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-43" data-mp="3dxjmlrvgwqro">+1.200</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-44" data-mp="2z59a8h16sugz">
              familias confían
            </p>
          </div>
          <div data-id="element-45" data-mp="2q64c3btjf35c">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-46" data-mp="2q6nvyy2r01m0">6</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-47" data-mp="2q4b864ab6x11">
              Tomos listos
            </p>
          </div>
          <div data-id="element-48" data-mp="2g7eyvwcl66vf">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-49" data-mp="2g8zrhgfcbfqn">5</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-50" data-mp="2l6rsczxyqc6z">
              Bonos incluidos
            </p>
          </div>
          <div data-id="element-51" data-mp="2mnip9kaoq6rj">
            <p className="text-3xl font-bold text-white mb-1 flex items-center justify-center gap-1" data-id="element-52" data-mp="2mn0ku0dvcm8j">
              4.9/5 <Star className="w-6 h-6 fill-amber-400 text-amber-400" data-id="element-53" data-mp="2hrv0v7411hn3" />
            </p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-54" data-mp="2vp05d2o3e8g8">
              calificación
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-55" data-mp="230kyx4j10ygi">
          <Card className="bg-slate-900" data-id="element-56" data-mp="23149g06ckkki">
            <div className="flex gap-1 mb-4" data-id="element-57" data-mp="1yzj18s4rcugn">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-58" data-mp="2cqe15exa4183" data-mpi={i} />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-59" data-mp="27ymgtm4purqe">
              "En pocos días dejó atrás los accidentes de pis. Tener el paso a
              paso nos devolvió la calma en casa."
            </p>
            <div className="flex items-center gap-3" data-id="element-60" data-mp="1f979p7g69izr">
              <div className="w-10 h-10 rounded-full bg-brand-900 flex items-center justify-center text-brand-400 font-bold" data-id="element-61" data-mp="3feb3ckear2b2">
                MG
              </div>
              <div data-id="element-62" data-mp="3p3cik8d0pfnz">
                <p className="font-bold text-white" data-id="element-63" data-mp="3p2t1suz3sxbj">Mariana G.</p>
                <p className="text-xs text-slate-500" data-id="element-64" data-mp="3p5oyyh34nhyx">Córdoba</p>
              </div>
            </div>
          </Card>

          <Card className="bg-slate-900" data-id="element-65" data-mp="2wex5hrdg57fa">
            <div className="flex gap-1 mb-4" data-id="element-66" data-mp="2wfys8t3tricu">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-67" data-mp="31ejj41x6spom" data-mpi={i} />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-68" data-mp="3ae6iyja9pnfk">
              "Por fin entendimos cómo frenar el mordisqueo destructivo sin
              retos eternos. Su comportamiento cambió muchísimo."
            </p>
            <div className="flex items-center gap-3" data-id="element-69" data-mp="pnfxcdzl01ay">
              <div className="w-10 h-10 rounded-full bg-emerald-900 flex items-center justify-center text-emerald-400 font-bold" data-id="element-70" data-mp="pqadvufh51z3">
                LP
              </div>
              <div data-id="element-71" data-mp="265y5zoc4hb4n">
                <p className="font-bold text-white" data-id="element-72" data-mp="266rdiriwo4nu">Laura P.</p>
                <p className="text-xs text-slate-500" data-id="element-73" data-mp="21cwln0t5cjdo">Rosario</p>
              </div>
            </div>
          </Card>

          <Card className="bg-slate-900" data-id="element-74" data-mp="1webtzpryn80u">
            <div className="flex gap-1 mb-4" data-id="element-75" data-mp="1rfqr1ilbqa8p">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-76" data-mp="1mgnn61h2ya2b" data-mpi={i} />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-77" data-mp="1ifc7ano0d37b">
              "Ahora duerme tranquilo y todos descansamos mejor. Tener una
              rutina clara hizo a nuestra familia mucho más feliz."
            </p>
            <div className="flex items-center gap-3" data-id="element-78" data-mp="3cr0n0s22d9sr">
              <div className="w-10 h-10 rounded-full bg-blue-900 flex items-center justify-center text-blue-400 font-bold" data-id="element-79" data-mp="37v1tyr5sj3m0">
                RM
              </div>
              <div data-id="element-80" data-mp="29i7c50uxxosj">
                <p className="font-bold text-white" data-id="element-81" data-mp="29ipgkkrrb9bj">Roberto M.</p>
                <p className="text-xs text-slate-500" data-id="element-82" data-mp="29ftk70vk4sp7">Buenos Aires</p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}
export function Problem() {
  return <section className="py-12 px-4" data-id="element-83" data-mp="1lslggnds1rpa">
      <div className="max-w-3xl mx-auto" data-id="element-84" data-mp="1lsd5j117swgq">
        <h2 className="text-2xl md:text-4xl font-bold text-center text-white mb-5" data-id="element-85" data-mp="1lqifx9f00g6b">
          ¿Cuántos días más vas a sentirte así?
        </h2>

        <p className="text-slate-300 text-center text-[16px] mt-[11px] mb-[11px]" data-id="element-86" data-mp="1cspzu31gd4hv">
          Querés darle a tu cachorro un buen comienzo. Querés educarlo con amor.
          Pero nadie te dijo que las primeras semanas podían sentirse como un
          caos: pis por toda la casa, mordidas, noches sin dormir y la duda de
          si lo estás haciendo bien.
        </p>

        <p className="text-lg font-bold text-center text-brand-400 mb-6" data-id="element-87" data-mp="o7245i3mgo5d">
          No es falta de amor. Es falta de una guía clara.
        </p>

        <Card className="bg-slate-900/80 border-red-900/30 mb-6" data-id="element-88" data-mp="j90icpetaaq7">
          <ul className="space-y-3" data-id="element-89" data-mp="y4yfa9wk7j3h">
            {['Limpiás accidentes de pis una y otra vez sin saber cómo prevenirlos', 'Muerde muebles, manos y objetos porque todavía no conoce los límites', 'Las noches se hacen largas y nadie logra descansar bien', 'Probás consejos distintos y cada persona te dice algo diferente', 'Querés que se porte mejor, pero no sabés qué entrenar primero', 'La familia se frustra cuando convivir debería ser una alegría'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-90" data-mp="1bypkx7766itx" data-mpi={i}>
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-91" data-mp="1px76ozdill97" />
                <span className="text-slate-300 text-lg" data-id="element-92" data-mp="1lvlmesyni4oz">{item}</span>
              </li>)}
          </ul>
        </Card>

        <h3 className="text-2xl md:text-3xl font-bold text-center text-white" data-id="element-93" data-mp="1szk16ur8emoo">
          ¿Y si esta fuera la última semana de caos?
        </h3>
      </div>
    </section>;
}